export const  initialState = {
    showModalWindow: false,
    permission: false,
    createEditFormValue: {
        top: "0.00",
        bottom: "0.00",
        left: "0.00",
        right: "0.00",
    },
    printFormValues: {
        name: "",
        is_target_printer: false,
        remarks: "",
        procedure_y_1: "",
        procedure_y_2: "",
        procedure_y_3: "",
        procedure_y_4: "",
        procedure_y_5: "",
        procedure_y_6: "",
    },
    loading: false,
    actionType: "edit",
    notifyMessage: "",
    showNotification: false,
    statusTag: "",
    tableData:[],
    hcfaCoordinates: null,
    originalCoordinates: null,
    currOpenId:"",
    idToDelete: null,
    currentSelectedCoordinateId: "",
    cmsPrintCoordinates: {
        display_name: "",
        x: "",
        y: "",
        max_char_length: "0",
        remarks: "",
        searchValue:""
    },
    cmsPrintCoordinatesModal: false,
    editMarginModal: false,
    printSettingsModal: false,

    activeTab: "tab1",
    showPrintConfigTab: false,
    showDeleteModalWindow: false,
    openAddModal: false,
    searchValue:"",
    openSection: {},
    expandAll: false,
    coordinates: [],
    editedCoordinates: {},
    selectedSection: null,
    groupedData: {},
    appliedSearchValue: "",
    searchValueFlag: false
}